import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminAudit() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/audit?limit=200");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="p-8 max-w-6xl">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono">// audit log</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Activity</h1>
        </div>
        <Button variant="ghost" onClick={load} className="text-zinc-400 hover:text-zinc-100" data-testid="audit-refresh-btn">
          <RefreshCw className="w-4 h-4 mr-1.5" /> Refresh
        </Button>
      </div>

      <Card className="bg-zinc-900/60 border-zinc-800 overflow-hidden">
        <div className="grid grid-cols-12 px-4 py-2 border-b border-zinc-800 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
          <div className="col-span-3">Timestamp</div>
          <div className="col-span-3">Action</div>
          <div className="col-span-3">User ID</div>
          <div className="col-span-2">Detail</div>
          <div className="col-span-1 text-right">IP</div>
        </div>
        <div className="divide-y divide-zinc-800 max-h-[70vh] overflow-auto">
          {items.map((i) => (
            <div key={i.id} className="grid grid-cols-12 px-4 py-2.5 text-xs font-mono hover:bg-zinc-900" data-testid={`audit-${i.id}`}>
              <div className="col-span-3 text-zinc-500">{new Date(i.created_at).toLocaleString()}</div>
              <div className="col-span-3 text-zinc-200">{i.action}</div>
              <div className="col-span-3 text-zinc-500 truncate">{i.user_id || "—"}</div>
              <div className="col-span-2 text-zinc-400 truncate">{i.detail}</div>
              <div className="col-span-1 text-right text-zinc-500 truncate">{i.ip_address || "—"}</div>
            </div>
          ))}
          {items.length === 0 && <div className="p-12 text-center text-sm text-zinc-500">No activity logged.</div>}
        </div>
      </Card>
    </div>
  );
}
